import { render, staticRenderFns } from "./StumpageForm.vue?vue&type=template&id=a4042ce6"
import script from "./StumpageForm.vue?vue&type=script&lang=js"
export * from "./StumpageForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports